<template>
  <div class='container-fluid'>
    <PreferredBoards/>
    <b-button v-b-toggle.boards variant="primary">Show all</b-button>
    <b-collapse id='boards' class="mt-2">
      <TeamBoards v-for="team in teams"
                  v-bind:key="team.id"
                  :team="team"
                  class="team-board" />
    </b-collapse>
    <footer>
      Board privacy legend:
      <b-badge pill variant="primary">Public</b-badge>
      <b-badge pill variant="info">Board members</b-badge>
      <b-badge pill variant="warning">Single user</b-badge>
    </footer>
  </div>
</template>

<script>
import TeamBoards from './TeamBoards'
import PreferredBoards from './PreferredBoards'
export default {
  name: 'DashBoard',
  components: {
    TeamBoards,
    PreferredBoards
  },
  data () {
    return {
      teams: [],
      boards: []
    }
  },
  created () {
    this.getTeams()
  },
  methods: {
    getTeams () {
      var vm = this
      this.$http
        .get('/teams')
        .then(function (response) {
          vm.teams = response.data
        })
        .catch(e => { console.log(e.response) })
    }
  }
}
</script>

<style scoped>
  * {
    text-align: left;
  }
  .team-board {
    margin-bottom: 10px;
  }
  footer {
    text-align: right;
  }
</style>



// WEBPACK FOOTER //
// src/components/DashBoard.vue